var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultTemplate',[_c('DefaultError',{attrs:{"page":'not-allowed'}},[_c('h1',{staticClass:"text-grey color-60 pd-t-5"},[_vm._v(" ขออภัย คุณไม่มีสิทธิเข้าถึงหน้านี้"),_c('br'),_c('span',{staticClass:"text-white not-hover cursor-pointer",on:{"click":_vm.backPage}},[(_vm.pageActive != null)?_c('u',[_vm._v("ย้อนกลับ")]):_vm._e()])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }